import {
  getVideoAnnotations,
  createAnnotation,
  updateAnnotation,
  deleteAnnotation,
  getTemplates,
  createTemplate,
  updateTemplate,
  deleteTemplate,
} from 'lib/api';
import {
  ANNOTATIONS_ACTIONS,
  CreateParams,
  QueryParams,
  UpdateAnnotationParams,
} from '.';

const {
  GET_ANNOTATIONS_START,
  GET_ANNOTATIONS_ERROR,
  GET_ANNOTATIONS_SUCCESS,
  ADD_ANNOTATIONS_START,
  ADD_ANNOTATIONS_ERROR,
  ADD_ANNOTATIONS_SUCCESS,
  EDIT_ANNOTATIONS_START,
  EDIT_ANNOTATIONS_ERROR,
  EDIT_ANNOTATIONS_SUCCESS,
  DELETE_ANNOTATIONS_START,
  DELETE_ANNOTATIONS_ERROR,
  DELETE_ANNOTATIONS_SUCCESS,
  GET_TEMPLATES_START,
  GET_TEMPLATES_ERROR,
  GET_TEMPLATES_SUCCESS,
  ADD_TEMPLATES_START,
  ADD_TEMPLATES_ERROR,
  ADD_TEMPLATES_SUCCESS,
  EDIT_TEMPLATES_START,
  EDIT_TEMPLATES_ERROR,
  EDIT_TEMPLATES_SUCCESS,
  DELETE_TEMPLATES_START,
  DELETE_TEMPLATES_ERROR,
  DELETE_TEMPLATES_SUCCESS,
} = ANNOTATIONS_ACTIONS;

export const loadVideoAnnotations = async ({
  videoId,
  customerId,
  dispatch,
}: QueryParams): Promise<void> => {
  dispatch({ type: GET_ANNOTATIONS_START });

  const response = await getVideoAnnotations({ videoId }).catch(err => err);
  if (response instanceof Error) {
    dispatch({
      type: GET_ANNOTATIONS_ERROR,
      error: response.message,
    });
    return;
  }
  dispatch({
    type: GET_ANNOTATIONS_SUCCESS,
    payload: {
      videoId,
      customerId,
      annotations: response.videoAnnotations,
      companyAnnotations: response.companyAnnotations,
    },
  });
};

export const addAnnotation = async ({
  data,
  dispatch,
}: CreateParams): Promise<void> => {
  dispatch({ type: ADD_ANNOTATIONS_START });

  const annotation = await createAnnotation({
    data,
    videoId: data.videoId,
  }).catch(err => err);

  if (annotation instanceof Error) {
    dispatch({
      type: ADD_ANNOTATIONS_ERROR,
      error: annotation.message,
    });
    return;
  }

  dispatch({
    type: ADD_ANNOTATIONS_SUCCESS,
    payload: {
      videoId: data.videoId,
      annotation,
      customerId: data.customerId,
    },
  });
};

export const editAnnotation = async (
  params: UpdateAnnotationParams
): Promise<void> => {
  const { data, dispatch, videoId, customerId } = params;
  dispatch({ type: EDIT_ANNOTATIONS_START });

  const annotation = await updateAnnotation({
    videoId,
    annotationId: data.annotationId,
    data,
  }).catch(err => err);

  if (annotation instanceof Error) {
    dispatch({
      type: EDIT_ANNOTATIONS_ERROR,
      error: annotation.message,
    });
    return;
  }

  dispatch({
    type: EDIT_ANNOTATIONS_SUCCESS,
    payload: {
      videoId,
      annotation,
      customerId: customerId,
    },
  });
};

export const removeAnnotation = async ({
  data,
  dispatch,
}: CreateParams): Promise<void> => {
  dispatch({ type: DELETE_ANNOTATIONS_START });

  const annotation = await deleteAnnotation(
    data.videoId,
    data.annotationId,
    data.isCompanyAnnotation
  ).catch(err => err);
  if (annotation instanceof Error) {
    dispatch({
      type: DELETE_ANNOTATIONS_ERROR,
      error: annotation.message,
    });
    return;
  }
  const payload = {
    videoId: data.videoId,
    annotationId: data.annotationId,
    customerId: data.customerId,
  };
  dispatch({ type: DELETE_ANNOTATIONS_SUCCESS, payload });
};

export const loadAnnotationsTemplates = async ({
  dispatch,
}: QueryParams): Promise<void> => {
  dispatch({ type: GET_TEMPLATES_START });

  const response = await getTemplates().catch(err => err);
  if (response instanceof Error) {
    dispatch({
      type: GET_TEMPLATES_ERROR,
      error: response.message,
    });
    return;
  }
  dispatch({
    type: GET_TEMPLATES_SUCCESS,
    payload: {
      templates: response,
    },
  });
};

export const addTemplate = async ({
  data,
  dispatch,
}: CreateParams): Promise<void> => {
  dispatch({ type: ADD_TEMPLATES_START });

  const template = await createTemplate({ data }).catch(err => err);
  if (template instanceof Error) {
    dispatch({
      type: ADD_TEMPLATES_ERROR,
      error: template.message,
    });
    return;
  }

  dispatch({
    type: ADD_TEMPLATES_SUCCESS,
    payload: {
      template,
    },
  });
};

export const editTemplate = async ({
  data,
  dispatch,
}: CreateParams): Promise<void> => {
  dispatch({ type: EDIT_TEMPLATES_START });

  const template = await updateTemplate({ data }).catch(err => err);
  if (template instanceof Error) {
    dispatch({
      type: EDIT_TEMPLATES_ERROR,
      error: template.message,
    });
    return;
  }

  dispatch({
    type: EDIT_TEMPLATES_SUCCESS,
    payload: {
      template,
    },
  });
};

export const removeTemplate = async ({
  data,
  dispatch,
}: CreateParams): Promise<void> => {
  dispatch({ type: DELETE_TEMPLATES_START });

  const template = await deleteTemplate(data.templateId).catch(err => err);
  if (template instanceof Error) {
    dispatch({
      type: DELETE_TEMPLATES_ERROR,
      error: template.message,
    });
    return;
  }
  const payload = {
    templateId: data.templateId,
  };
  dispatch({ type: DELETE_TEMPLATES_SUCCESS, payload });
};
